export default __webpack_public_path__ + "static/media/trace-image-full.710c18f7.png";